import { app } from '../../../../bootstrap/core';
import { historyEntryListComponent } from './historyEntryList.component';

app.component('historyEntryList', historyEntryListComponent);
